import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['price', 'animation'];

  initialize() {
    this.timeout = null;
    this.cart = false;
  }

  connect() {
    this.priceInput().addEventListener('change', () => this.updatePrice());
    this.priceInput().addEventListener('keydown', () => this.updatePrice());
  }

  disconnect() {
    this.priceInput().removeEventListener('change', () => this.updatePrice());
    this.priceInput().removeEventListener('keydown', () => this.updatePrice());
  }

  priceInput() {
    let element = this.element.closest('tr').querySelector('[data-target="store--add-to-cart.quantity"]');
    if (element == null) {
      this.cart = true;
      element = this.element.closest('tr').querySelector('[data-target="store--cart-items--change-quantity.quantity"]');
    }
    return element
  }

  updatePrice() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const previousPrice = this.priceTarget.innerText;

      this.animationTarget.classList.remove('animated');
      this.animationTarget.classList.remove('jello');

      let quantity = this.priceInput().value;
      if (this.cart) {
        quantity = 0;
      }

      fetch(`${this.data.get('url')}.json?quantity=${quantity}`, { credentials: 'same-origin' })
        .then(response => {
          return response.json();
        })
        .then(priceData => {
          this.priceTarget.innerText = priceData.price;

          // Проверяем с помощью includes, а не просто стравнением, потому что в previousPrice попадают пробелы.
          if (!previousPrice.includes(priceData.price)) {
            this.animationTarget.classList.add('animated');
            this.animationTarget.classList.add('jello');
          }
        })
    }, 200);
  }
}
